<div class="my-5">
  <sm-page-header [breadcrumb]="breadcrumb" title="settings.dynaDocsModels.title">
  </sm-page-header>
  <div class="content">
    <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [loading]="loading" [totalRecords]="totalRecords"></sm-data-table-builder>
  </div>

  <sm-drawer #drawerRef [drawer]="drawer"></sm-drawer>
  <sm-dialog #dialogRef [dialog]="dialog"></sm-dialog>
</div>
